/** Écran d'authentification : connexion ou création de compte. */
import { type FormEvent, useState } from 'react';
import { useAuth } from '@/lib/auth';

export function LoginPage() {
  const { login, register } = useAuth();
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      if (mode === 'login') await login(email, password);
      else await register(email, password);
    } catch (err) {
      setError(
        mode === 'login'
          ? 'Identifiants invalides.'
          : 'Impossible de créer le compte (email déjà utilisé ou mot de passe trop court, min. 8 caractères).',
      );
      console.error(err);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="center-screen">
      <form className="card auth-card" onSubmit={submit}>
        <div className="brand" style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          K<span>CAL</span>
        </div>
        <h2 style={{ textAlign: 'center' }}>
          {mode === 'login' ? 'Connexion' : 'Créer un compte'}
        </h2>
        <p className="muted" style={{ textAlign: 'center', marginTop: 0 }}>
          Suivi calorique &amp; poids
        </p>

        <div className="field">
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
          />
        </div>
        <div className="field">
          <label htmlFor="pw">Mot de passe</label>
          <input
            id="pw"
            type="password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
          />
        </div>

        {error && <p className="error">{error}</p>}

        <button type="submit" disabled={busy} style={{ width: '100%' }}>
          {busy ? '…' : mode === 'login' ? 'Se connecter' : "S'inscrire"}
        </button>

        <p className="muted" style={{ textAlign: 'center', marginBottom: 0, fontSize: '0.85rem' }}>
          {mode === 'login' ? 'Pas encore de compte ?' : 'Déjà un compte ?'}{' '}
          <button
            type="button"
            className="link"
            onClick={() => {
              setError('');
              setMode(mode === 'login' ? 'register' : 'login');
            }}
          >
            {mode === 'login' ? 'Créer un compte' : 'Se connecter'}
          </button>
        </p>
      </form>
    </div>
  );
}
